interface Props {
  speed: number;
  onChange: (x: number) => void;
}

const SPEEDS = [0.75, 1, 1.25, 1.5];

export function SpeedControl({ speed, onChange }: Props) {
  return (
    <div style={containerStyle}>
      {SPEEDS.map((s) => (
        <button
          key={s}
          style={s === speed ? activeStyle : btnStyle}
          onClick={() => onChange(s)}
        >
          {s}×
        </button>
      ))}
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 92,
  right: 24,
  display: 'flex',
  gap: 4,
  padding: 4,
  background: 'rgba(15,25,35,0.78)',
  border: '1px solid rgba(255,255,255,0.06)',
  borderRadius: 999,
  backdropFilter: 'blur(10px)',
  zIndex: 25,
  fontFamily: 'Inter, sans-serif',
};

const btnStyle: React.CSSProperties = {
  padding: '6px 12px',
  border: 'none',
  background: 'transparent',
  color: '#9CA3AF',
  fontSize: 13,
  fontWeight: 600,
  borderRadius: 999,
  cursor: 'pointer',
  minWidth: 44,
};

const activeStyle: React.CSSProperties = {
  ...btnStyle,
  background: '#F5B800',
  color: '#0F1923',
};
